
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from './hooks/use-auth';

// Componentes principales
import AdminRoutes from './routes/AdminRoutes';
import NotFound from './components/NotFound';

// Suspense fallback
import Loading from './components/layout/Loading';

// Importamos los componentes desde lazy-routes que sí existen
import { 
  Dashboard, 
  Users, 
  Departments, 
  KPIs, 
  Reports, 
  Settings, 
  Login,
  Register,
  ForgotPassword,
  ResetPassword,
  AccessRequests
} from './routes/lazy-routes';

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <Router>
        <AuthProvider>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/kpis" element={<KPIs />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/users" element={<Users />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/access-requests" element={<AccessRequests />} />
              
              {/* Rutas administrativas */}
              <Route path="/admin/*" element={<AdminRoutes />} />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Toaster />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
